export enum NavigationAction {
  Previous = -1,
  Next = 1
}
